import { LimitExceptionsUploadErrorItem } from '@/models/limit-exceptions-upload/limit-exceptions-upload.model';

export const limitExceptionsUploadErrorItemApiToDto = (
  errorItem: LimitExceptionsUploadErrorItem,
): string => {
  return `Row ${errorItem.rowNumber}: ${errorItem.errorMessage || errorItem.errorCode}`;
};
